import { FormState } from "./Aspects";

export const DEFAULT_PANEL: FormState[] = [
    {
        messages: ['SIN CONEXION', 'SIN CONEXION', 'SIN CONEXION'],
        pictogram: "/static/media/251.102ca7f6943f60cbd3ad.dib",
        textAlign: 'center',
        textSize: 20,
        textColor: '#ffffff',
    }
];

export const SUCCESS_PANEL: FormState[] = [
    {
        messages: ['', '', ''],
        pictogram: "none",
        textAlign: 'center',
        textSize: 20,
        textColor: '#ffffff',
    }
];